import React from 'react';
import AiLandingPage from '../components/About/AiLanding/AiLandingPage';
import Head from '../components/Header/Head';
import withApollo from '../lib/withApollo';

const AiPage = () => {
  return (
    <>
      <Head
        title="AI Travel Blog Writer That Works From Your Own Photos"
        description="TravelFeed's AI Blogger writes from your photos and an interview about your trip, never from thin air. No photos, no article. Built for travel bloggers who want posts that rank."
        image={`${process.env.NEXT_PUBLIC_ROOTURL}/img/ai-og.png`}
        seo={{ canonicalUrl: 'https://travelfeed.com/ai' }}
      />
      <AiLandingPage />
    </>
  );
};

export default withApollo(AiPage);
